import { render, staticRenderFns } from "./DataPropertyProfileTab.vue?vue&type=template&id=f8c52292&scoped=true&"
import script from "./DataPropertyProfileTab.vue?vue&type=script&lang=js&"
export * from "./DataPropertyProfileTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8c52292",
  null
  
)

export default component.exports